import { withCloseAfterExited } from "../modal";
import {
  default as View,
  ViewEntitlementModalProps
} from "./view-entitlement-modal-view";

const ViewEntitlementModal = withCloseAfterExited<ViewEntitlementModalProps>(
  View
);
export default ViewEntitlementModal;
